/**
 * Entity Roles constant.
 *
 * Provides an enum-like object representing entity roles.
 *
 * @readonly
 * @enum {string}
 */
export const ENTITY_ROLES = Object.freeze({
  OWNER: 'Owner',
  ADMIN: 'Admin',
  INSTRUCTOR: 'Instructor',
  MEMBER: 'Member',
})

/**
 * Options array derived from ENTITY_ROLES.
 *
 * Each option is an object with a `label` (display name) and `id` (value).
 * Intended for use in UI components like dropdowns, radio groups, or selects.
 *
 * @type {{label: string, id: string}[]}
 */
export const ROLE_OPTIONS = Object.values(ENTITY_ROLES).map((role) => ({
  label: role,
  id: role,
}))

/**
 * Active User Status Options.
 *
 * @type {{label: string, id: boolean}[]}
 */
export const ACTIVE_USER_STATUS_OPTIONS = [
  { label: 'All Users', id: null },
  { label: 'Active Users', id: true },
  { label: 'Invited Users', id: false },
]

export const SHOW_ALTERNATE_COURSES = false

const DOCUMENT_TYPES = ['Certificate', 'Roster', 'Upload']

export const DOCUMENT_TYPE_OPTIONS = DOCUMENT_TYPES.map((type) => ({
  label: type,
  id: type,
}))
